const isValidGuid = (uuid)=> {
  if (typeof uuid !== 'string') return false;
  const re = /^[{]?[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}[}]?$/i;
  return re.test(uuid);
}

export { isValidGuid };